__turbopack_context__.v({
  "btn": "hS5eoW_btn",
  "cards": "hS5eoW_cards",
  "container": "hS5eoW_container",
  "containerCard": "hS5eoW_containerCard",
  "h3Platform": "hS5eoW_h3Platform",
  "image": "hS5eoW_image",
  "imageContainer": "hS5eoW_imageContainer",
  "pPlatform": "hS5eoW_pPlatform",
  "paragraph": "hS5eoW_paragraph",
  "rowEtc": "hS5eoW_rowEtc",
  "textCategory": "hS5eoW_textCategory",
  "textH2": "hS5eoW_textH2",
  "title": "hS5eoW_title",
});
